import { useMutation } from "urql";

import { FreezeCustomerDocument } from "../../../graphql/generated.ts";

export const useFreezeCustomerStatus = () =>
  useMutation(FreezeCustomerDocument);
